module.exports = __webpack_public_path__ + "img/chevron-right.60094b84.svg";